import React, { ReactNode } from 'react';
import classes from './SplitRow.module.scss';
import clsx from 'clsx';
import Column from 'components/atoms/Column/Column';
import Txt from 'components/atoms/Txt/Txt';

export interface Props {
  className?: string;
  leftColumn?: ReactNode;
  rightColumn?: ReactNode;
  id?: string;
  rowTitle?: string;
  contentAlignedTop?: boolean;
  mobileColumnOrderSwapped?: boolean;
  hasBorderBottom?: boolean;
  isFirstRow?: boolean;
}

const SplitRow: React.FC<Props> = ({
  className,
  leftColumn,
  rightColumn,
  id,
  rowTitle,
  contentAlignedTop,
  mobileColumnOrderSwapped,
  hasBorderBottom,
  isFirstRow,
}) => {
  const columnContentAlignedTopClass = contentAlignedTop ? classes.contentAlignedTop : undefined;

  const columns = (
    <>
      {leftColumn && (
        <Column
          className={clsx(
            classes.column,
            columnContentAlignedTopClass,
            mobileColumnOrderSwapped && classes.mobileColumnOrderSecond,
          )}
        >
          {leftColumn}
        </Column>
      )}
      {rightColumn && (
        <Column className={clsx(classes.column, columnContentAlignedTopClass)}>
          {rightColumn}
        </Column>
      )}
    </>
  );

  if (rowTitle)
    return (
      <div id={id}>
        <div
          className={clsx(
            classes.columnContainer,
            hasBorderBottom && classes.borderBottom,
            isFirstRow && classes.isFirstRow,
          )}
        >
          <Txt component="h2" className={classes.rowTitle}>
            {rowTitle}
          </Txt>
          <div className={clsx(classes.root, className, classes.hasTitle)}>{columns}</div>
        </div>
      </div>
    );

  return (
    <div id={id}>
      <div
        className={clsx(
          classes.root,
          classes.columnContainer,
          hasBorderBottom && classes.borderBottom,
          contentAlignedTop && classes.contentAlignedTop,
          isFirstRow && classes.isFirstRow,
        )}
      >
        {columns}
      </div>
    </div>
  );
};

export default SplitRow;
